import { Component, Input } from '@angular/core';
import { AbstractControl } from '@angular/forms';
import { rollUpAnimation } from '../../animations';

@Component({
  selector: 'section-error',
  templateUrl: './section-error.component.html',
  styleUrls: ['./section-error.component.scss'],
  standalone: false,
  // TODO: ensure correct animation and tweak
  animations: [rollUpAnimation('rollUp', '1.5rem', '0.32s ease', '0.32s ease')],
})
export class SectionErrorComponent {
  @Input() control!: AbstractControl | null;
  @Input() errorName = '';

  get showError(): boolean {
    return !!this.control && this.control.touched && this.control.hasError(this.errorName);
  }
}
